import { Card, Col, Row } from 'react-bootstrap';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
import events from 'assets/img/th-each-ai/events.png';
import forum from 'assets/img/th-each-ai/forum.png';
import magazine from 'assets/img/th-each-ai/magazine.png';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import { useEffect, useState } from 'react';
import { Question } from 'pages/forum/components/DataDefinitions';

const CommunityDashboard = () => {

    const { t } = useTranslation();
    const auth = useAuth();
    const navigate = useNavigate();

    const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);
    // TODO da implementare
    const [isLoadingEvents, setIsLoadingEvents] = useState(true);

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('CommunityDashboard.page_title'),
            active: true
        }
    ];



    const [questions, setQuestions] = useState<Question[]>([]);
    const fetchData = async () => {

        try {
            setIsLoadingQuestions(true);
            const params = new URLSearchParams({
                query: '',
                limit: '5',
                offset: '0'
            });

            const response = await apiClient.get(`/v1/forum/search?${params}`);
            setQuestions(response.data['questions']);

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoadingQuestions(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <div className="mt-4">
                <Card className='border border-light rounded-5 mb-4' >
                    <Card.Body>
                        <div style={{ height: '70px' }} className='align-content-center '>
                            <p className="mb-0 mx-3 fs-8" style={{ 'textAlign': 'left' }}> {t("Blogs.headline")}</p>
                        </div>
                    </Card.Body>
                </Card>

                <Card className='border border-light rounded-5 mb-4' >
                    <Card.Body>
                        <Row className="mt-0 mb-2">
                            <Col sm={4} md={4} lg={4}>
                                <Card style={{ cursor: 'pointer' }} onClick={() => navigate('/community/events')} >
                                    <Card.Img variant="top" src={events} />
                                    <Card.Body className='bg-theachai-tiffany'>
                                        <Card.Title className='text-white m-0 p-0 fs-6'>{t('Blogs.events_card')}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm={4} md={4} lg={4}>
                                <Card style={{ cursor: 'pointer' }} onClick={() => navigate('/community/magazine')}>
                                    <Card.Img variant="top" src={magazine} />
                                    <Card.Body className='bg-theachai-dark-blue'>
                                        <Card.Title className='text-white m-0 p-0 fs-6'>{t('Blogs.magazine_card')}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm={4} md={4} lg={4}>

                                <Card style={{ cursor: 'pointer' }} onClick={() => navigate('/community/forum')}>
                                    <Card.Img variant="top" src={forum} />
                                    <Card.Body className='bg-theachai-yellow'>
                                        <Card.Title className='text-white m-0 p-0 fs-6'>{t('Blogs.forum_card')}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>



                <div className='mb-4 d-flex gap-2' >
                    <div className="w-50">
                        {!isLoadingEvents && <Card className='border border-light rounded-5' >
                            <Card.Body>
                                <h5 className="card-title">Latest events</h5>
                            </Card.Body>
                        </Card>
                        }
                    </div>
                    <div className="w-50">
                        {!isLoadingQuestions && <Card className='border border-light rounded-5' >
                            <Card.Body>
                                <h5 className="card-title">Latest questions</h5>

                                <div className="questions-list">
                                    {questions.map(question => (
                                        <div key={question.question_id} className="card mb-2">
                                            <div className="card-body m-0 pt-2 pb-2">
                                                <div className="row p-0">
                                                    {/* Question Content Column */}
                                                    <div className="col-md-8 align-content-center">
                                                        <div className="d-flex justify-content-between">
                                                            <h5 className="card-title">
                                                                {question.solved == 1 && (
                                                                    <Check className="text-success me-2" size={20} />
                                                                )}


                                                                <Link to={`/community/forum/question/${question.question_id}`}>
                                                                    {question.title}
                                                                </Link>

                                                            </h5>
                                                        </div>
                                                    </div>

                                                    {/* Requester and answeer Column */}
                                                    <div className="col-md-4 text-center">
                                                        <div className="d-flex flex-column align-items-center">
                                                            <div className="bg-light p-3 rounded text-secondary small">
                                                                by {question.author} on {question.inserted_at}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </Card.Body>
                        </Card>
                        }
                    </div>
                </div>


            </div>




        </>
    );
};

export default CommunityDashboard;
